import type { RouteRecordRaw } from "vue-router"
import { commonRoutes } from "@/ts/routes/common-routes"
import ReaderBookOverview from "@/window/ReaderBookOverview.vue"
import BookOverviewPage from "@/window/BookOverviewPage.vue"

export const targetRoutes: RouteRecordRaw[] = [
        {
                path: "/forgot/:id",
                name: "password-reset",
                component: () => import("@/window/AuthorizationPage.vue"),
                meta: { label: "Восстановление пароля", title: "Восстановление пароля — АСТ-ПРЕСС ШКОЛА" },
        },
        {
                path: "/auth",
                name: "authorization",
                component: () => import("@/window/AuthorizationPage.vue"),
                meta: { label: "Авторизация", navPath: "/auth", title: "Вход в аккаунт — АСТ-ПРЕСС ШКОЛА" },
        },
        {
                path: "/",
                name: "home",
                component: () => import("@/window/AboutEbookPage.vue"),
                props: { isLandingPage: true },
                meta: { label: "Об электронных учебниках", navPath: "/", title: "Электронные учебники АСТ-ПРЕСС ШКОЛА" },
        },
        {
                path: "/about-ebook",
                name: "about-ebook",
                component: () => import("@/window/AboutEbookPage.vue"),
                meta: { label: "Об электронных учебниках", navPath: "/about-ebook" },
        },
        {
                path: "/5kl/istoriya-nashego-kraya-moskva",
                name: "moscow-history-overview",
                component: BookOverviewPage,
                props: { overviewComponent: ReaderBookOverview },
                meta: { label: "Book overview", bookId: "istoriya-nashego-kraya-moskva", navPath: "/5kl/istoriya-nashego-kraya-moskva" },
        },
        {
                path: "/10kl/:bookId",
                name: "book-overview",
                component: BookOverviewPage,
                props: { overviewComponent: ReaderBookOverview },
                meta: { label: "Book overview", navPath: "/10kl/informatika" },
        },
        ...commonRoutes,
]
